<template>
  <a-spin :spinning="uploading">
    <div>
      <div class="row mt-3">
        <div class="col-sm-6 col-md-6 border">
          <div class="m-3">
            <div class="display-flex">
              <p class="bold-text mr-1">Upload User File</p>
              <a href="/admin-points-faq" target="_blank">
                <font-awesome-icon icon="question-circle" />
              </a>
            </div>
            <form
              v-on:submit.prevent="uploadUserFile()"
              enctype="multipart/form-data"
            >
              <div class="border">
                <div class="marginAll">
                  <label>File</label>
                  <b-form-file
                    v-model="UserFile"
                    type="file"
                    id="user-file"
                    name="userfile"
                    class="mt-1"
                    plain
                    :disabled="!canUploadUsers"
                  >
                  </b-form-file>

                </div>
              </div>
              <div class="border">
                <div class="marginAll">
                  <label>File Type</label>
                  <b-form-radio
                    v-model="UserFileType"
                    :aria-describedby="ariaDescribedby"
                    value="users"
                    >Excel
                  </b-form-radio>
                </div>
              </div>
              <p class="marginAll">
                Please be patient when uploading files. Large files can take
                several minutes to process.
              </p>
              <input
                class="btn btn-primary btn-lg btn-sm-block mr-1 my-2"
                type="button"
                name="upload"
                value="Upload User Data"
                @click="showUploadConfirm = true"
                :disabled="!canUploadUsers"
              />
            </form>
            <hr />
            <p>
              NOTE: You must use the
              <a style="color: #1890ff" @click="downloadBlankTemplate">
                Excel</a
              >
              user template as the basis for your upload file. If you are unsure
              of how to use the template, check out the
              <a
                href="/admin-points-faq"
                target="_blank"
                style="text-decoration: none"
                >Frequently Asked Questions</a
              >
              or click on the
              <a href="/admin-points-faq" target="_blank">
                <font-awesome-icon icon="question-circle" />
              </a>
              for context sensitive help.
            </p>
            <hr />
            <p>
              The Excel file has a company_name and a company_id column. To
              upload data successfully, one of these columns
              <strong>MUST</strong> be filled with the ID or exact name of a
              company or location that you administer. The Authorized companies
              or locations matrix on the right lists the proper values for these
              two columns. Remember, each record must have either a company_name
              or a company_id.
            </p>
          </div>
        </div>
        <div class="col-sm-6 col-md-6 border">
          <div class="m-3">
            <div class="display-flex">
              <p class="bold-text mr-1">Build New User File</p>
              <a href="/admin-points-faq" target="_blank">
                <font-awesome-icon icon="question-circle" />
              </a>
            </div>
            <div class="border">
              <div class="marginAll">
                <label>Choose Companies to include</label>
                <b-form-select
                  multiple
                  v-model="Companies"
                  :options="CompaniesOption"
                  :select-size="4"
                ></b-form-select>
                This is the list of your authorized companies or locations.
              </div>
            </div>
            <div class="border">
              <div class="marginAll">
                <label>File Type to Build</label>
                <b-form-radio
                  v-model="BuildFileType"
                  :aria-describedby="ariaDescribedby"
                  :value="true"
                  >CSV
                </b-form-radio>
              </div>
            </div>
            <div class="border">
              <div class="marginAll">
                <label>User Type</label>
                <b-form-checkbox
                  v-model="BuildUserType"
                  :aria-describedby="ariaDescribedby"
                  :value="true"
                  >Include Deleted Users?</b-form-checkbox
                >
              </div>
            </div>
            <form v-on:submit.prevent="buildNewUserFile()">
              <input
                class="btn btn-primary btn-lg btn-sm-block mr-1 my-3"
                type="submit"
                name="build"
                :value="uploading ? 'Processing' : 'Build New User File'"
                :disabled="uploading"
              />
            </form>
            <CSVToExcelInstructions></CSVToExcelInstructions>
            <div class="border">
              <div class="marginAll">
                <label
                  >Download Blank Templates
                  <a href="/admin-points-faq" target="_blank">
                    <font-awesome-icon icon="question-circle" />
                  </a>
                </label>

                <p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 384 512"
                    width="14px"
                    height="14px"
                    style="fill: #3782f3"
                  >
                    <path
                      d="M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm160-14.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
                    />
                  </svg>
                  Blank Excel Template [
                  <a style="color: #1890ff" @click="downloadBlankTemplate">
                    Download</a
                  >
                  ]
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row my-3">
        <UserUploadSummary previousRoute="AdminBatchUserUploadToolMain" activeMenuItem="usersBatchUserUploadTool" />
        <div class="col-sm-12 col-lg-6 col-md-6">
          <div class="row">
            <div class="col-sm-12 col-lg-12 col-md-12">
              <div style="text-align: center">
                <label> Authorized companies or locations</label>
              </div>
              <b-table
                class="
                  table
                  table-hover
                  table-responsive
                  table-bordered
                  table-striped
                  my-1
                "
                responsive="sm"
                sort-icon-right
                style="width: 100%"
                hover
                :fields="ClientFields"
                :items="ClientItems"
              >
              </b-table>
              <div style="text-align: center">
                <label
                  >Authorized Programs
                  <a href="/admin-points-faq" target="_blank">
                    <font-awesome-icon icon="question-circle" />
                  </a>
                </label>
              </div>
              <div
                class="col-sm-12 col-lg-12 col-md-12 p-2"
                v-for="Program in allClientsProgram"
                :key="Program.client_id"
              >
                <div style="text-align: center">
                  <label>{{ Program.client_name }}</label>
                </div>
                <b-table
                  v-if="Program.authorized_clients_programs.length > 0"
                  class="
                    table table-hover table-responsive table-bordered
                    my-1
                    table-striped
                  "
                  responsive="sm"
                  sort-icon-right
                  style="width: 100%"
                  hover
                  :fields="getFields(Program.authorized_clients_programs)"
                  :items="Program.authorized_clients_programs"
                >
                </b-table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <a-modal
        v-model="showUploadConfirm"
        :footer="null"
        width="720px"
        class="upload-confirm-modal"
        @cancel="showUploadConfirm = false"
        :maskClosable="false"
      >
        <div class="modal-title">Confirm Upload</div>

        <div class="modal-body">
          <p class="modal-text"><strong>Are you sure?</strong></p>
          <p class="modal-text">
            A bulk action is about to be performed and will affect multiple users.<br/>  
            Large files may take some time to process so please be patient.
          </p>
        </div>

        <div class="modal-footer-custom">
          <a-button @click="showUploadConfirm = false">
            Cancel
          </a-button>

          <a-button type="primary" @click="confirmUpload">
            Upload
          </a-button>
        </div>
      </a-modal>

    </div>
  </a-spin>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import AdminSidebar from "@/views/admin/AdminSidebar.vue";
import Modal from "@/components/Modal.vue";
import { saveAs } from "file-saver";
import { fileDownload } from "@/utilities/downloadFile.js";
import UserUploadSummary from "../../../../components/UserUploadSummary.vue";
import CSVToExcelInstructions from "../../../../components/CSVToExcelInstructions.vue";

function decodeJWT(token) {
  if (!token) return null;

  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');

    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );

    return JSON.parse(jsonPayload);
  } catch {
    return null;
  }
}

export default {
  name: "BatchUserUploadTool",

  props: {
    activeMenuItem: String,
    activeMenu: String,
  },

  components: {
    appHeader: Header,
    appFooter: Footer,
    appAdminSidebar: AdminSidebar,
    appModal: Modal,
    UserUploadSummary,
    CSVToExcelInstructions,
  },

  data() {
    return {
      UserFile: null,
      UserFileType: false,
      ariaDescribedby: null,
      BuildFileType: false,
      BuildUserType: false,
      Companies: [],
      CompaniesOption: [],
      uploading: false,

      ClientItems: [],
      AllClientsProgram: [],
      AllClientForm: {},
      ClientFields: [
        {
          key: "client_name",
        },
        {
          key: "client_id",
        },
      ],
      showUploadConfirm: false,
    };
  },

  methods: {
    getFields: function(fields) {
      var data = [];
      fields.forEach((value, index) => {
        data = Object.keys(value);
      });

      return data;
    },
    confirmUpload() {
      this.showUploadConfirm = false;
      this.uploadUserFile();
    },
    setActiveMenuItem: function () {
      this.$store.dispatch("adminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "usersBatchUserUploadTool",
        activeMenu: this.activeMenu ? this.activeMenu : "users",
      });
    },

    buildNewUserFile() {
      if (this.Companies.length < 1) {
        this.$store.dispatch("systemMessage/setModalMessage", {
          message: "Select any company",
        });
      } else if (!this.BuildFileType) {
        this.$store.dispatch("systemMessage/setModalMessage", {
          message: "Select file type",
        });
      }

      if (this.Companies.length && this.BuildFileType) {
        // this.$store.dispatch("systemMessage/setModalMessage", {
        //   message: "",
        // });

        this.uploading = true;
        const params = {
          clientIds: this.Companies,
          includedDeletedUsers: this.BuildUserType,
        };

        this.$store
          .dispatch(
            "adminBatchUserUploadTool/fetchUsersForBatchUploadFile",
            params
          )
          .then((file) => {
            this.Companies = [];
            this.BuildFileType = false;

            this.$store.dispatch("systemMessage/setModalMessage", {
              message:
                "Your new user file is ready. It will automatically download once done.",
            });

            saveAs(
              new Blob([file]),
              `UserFile_${
                new Date().getFullYear() +
                "" +
                (new Date().getMonth() + 1) +
                "" +
                new Date().getDate()}.csv`
            );
          })
          .catch((err) => {
            console.log("error from batch upload file", err);
          })
          .finally(() => {
            this.uploading = false;
          });
      }
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },

    uploadUserFile() {
      if (this.UserFile === null) {
        this.$store.dispatch("systemMessage/setModalMessage", {
          message: "Select file",
        });
      } else if (!this.UserFileType) {
        this.$store.dispatch("systemMessage/setModalMessage", {
          message: "Select file type",
        });
      }

      if (this.UserFile && this.UserFileType) {
        var formData = new FormData();
        var userFile = this.UserFile;

        formData.append("batchuseruploadfile", userFile);
        this.uploading = true;
        this.$store
          .dispatch("adminBatchUserUploadTool/insertUserFileData", formData)
          .then((status) => {
            this.uploading = false;
            if (status) {
              this.UserFile = null;
              this.UserFileType = null;
              // summary update
              this.$store.dispatch(
                "adminBatchUserUploadTool/fetchUserUploadSummary"
              );

              // scrolling to top
              this.scrollToTop();

              // open modal, show message
              this.$store.dispatch("systemMessage/setModalMessage", {
                message:
                  "Your data has been uploaded. Use the tools below to edit and finalize your inserts and updates",
              });
              this.getFormUsers();
            }
          })
          .catch((err) => {
            this.$store.dispatch("systemMessage/setModalMessage", {
              message: err || "error while uploading file",
            });
            this.uploading = false;
          });
      }
    },
    getFormUsers() {
      this.$store
        .dispatch("adminBatchUserUploadTool/fetchUsersPrograms")
        .then((programs) => {
          if (programs) {
            this.AllClientForm = programs.reduce(
              (
                currentValue,
                { program_id, program_name, total, totalPoints, actiontype }
              ) => {
                return {
                  ...currentValue,
                  [program_id]: {
                    EMAIL_MESSAGE: "",
                    EMAIL_MESSAGE: "",
                    PROGRAM_ID: program_id,
                    PROGRAM_NAME: program_name,
                  },
                };
              },
              {}
            );
            this.AddPointPrograms = programs.filter(
              (prgm) => prgm.actiontype === "Update: Add points"
            );
          } else this.AllClientsProgram = {};
        });
    },
    
    downloadBlankTemplate() {
      this.$store
        .dispatch("adminBatchUserUploadTool/downloadBlankTemplate", {
          ft: "batchuserupload",
        })
        .then((data) => {
          saveAs(new Blob([data]), "BatchUserUpload_template.xlsx");
        })
        .catch((err) => {
          alert(err.data.message);
        });
    },
  },

  computed: {
    authorizedClients() {
      return this.$store.getters["adminPointPrograms/getAuthorizedClients"];
    },
    allClientsProgram() {
      var programs =
        this.$store.getters["adminBatchUserUploadTool/getAllClientsProgram"];

      var datas = programs.map(function (data) {
        return {
          client_id: data.clientId,
          client_name: data.clientName,
          authorized_clients_programs: data.authorizedClientsPrograms.map(
            function (program) {
              return {
                program_id: program.programId,
                program_name: program.programName,
              };
            }
          ),
        };
      });

      return datas;
    },
    getModalMessage() {
      return this.$store.getters["systemMessage/getModalMessage"];
    },
    getAllBatchUploadUsers() {
      return this.$store.getters[
        "adminBatchUserUploadTool/getAllBatchUploadUsers"
      ];
    },
    PointActionsItems() {
      return this.$store.getters["adminBatchUserUploadTool/getUsersPrograms"];
    },
    loggedInUserId() {
      const token = localStorage.getItem("jwtToken");
      const payload = decodeJWT(token);
      return payload?.user_id || null;
    },

    canUploadUsers() {
      // ✅ ONLY this user can upload users
      return this.loggedInUserId !== 736036;
    },
  },

  watch: {
    authorizedClients(authorizedClients) {
      var datas = [];
      authorizedClients.map(function (data) {
        datas.push({
          client_id: data.clientId,
          client_name: data.clientName,
        });
      });

      var new_datas = [{ value: 0, text: "All Users" }];
      authorizedClients.map(function (data) {
        new_datas.push({
          value: data.clientId,
          text: data.clientName,
        });
      });

      this.CompaniesOption = new_datas;
      this.ClientItems = datas;
    },
   
  },

  mounted() {
    console.log('[BatchUserUploadTool] loggedInUserId =', this.loggedInUserId);

    this.setActiveMenuItem();
    this.scrollToTop();
    this.$store.dispatch("adminPointPrograms/fetchAuthorizedClients");
    this.$store.dispatch("adminBatchUserUploadTool/fetchAllClientsProgram", {
      clientId: 0,
      status: "Active",
    });
    this.$store.dispatch("adminBatchUserUploadTool/fetchUserUploadSummary");
    this.getFormUsers();

    // Reload page confirmation when uploading
    window.addEventListener("beforeunload", (e) => {
      if (this.uploading) {
        e.returnValue = "Still Waiting!";
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.admin-batch-user-upload-tool {
  margin: -14px 0 0 0;

  .badge {
    font-size: 0.8rem;
    padding: 6px 0px;
    border-radius: $border-radius-sm;
  }
}

.align-right {
  text-align: right;
}

.bold-text {
  font-weight: bold;
}

.display-flex {
  display: flex;
}

.marginAll {
  margin: 10px;
}
/* Confirmation modal styling */
.upload-confirm-modal .ant-modal-content {
  border-radius: 14px !important;
  padding: 0 !important;
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.18);
  border: none;
}

/* Title */
.upload-confirm-modal .modal-title {
  font-size: 18px;
  font-weight: 700;
  padding: 18px 22px;
  border-bottom: 1px solid #eee;
}

/* Body text */
.upload-confirm-modal .modal-body {
  padding: 20px 22px 10px 22px;
}

.upload-confirm-modal .modal-text {
  font-size: 15px;
  margin-bottom: 8px;
  color: rgba(0, 0, 0, 0.8);
}

/* Footer / buttons */
.upload-confirm-modal .modal-footer-custom {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 15px 22px 25px 22px;
}

/* Buttons look modern */
.upload-confirm-modal .ant-btn {
  height: 34px;
  font-size: 14px;
  padding: 0 18px;
  border-radius: 6px;
}

.upload-confirm-modal .ant-btn-primary {
  background: #1677ff;
  border-color: #1677ff;
}

</style>
